import React, {createContext, useState} from 'react';
import {Toast} from "../../components/common/Toast";
import {getErrorMessage} from "../../helpers/Utils";
import BranchOrderService from "../../services/order/BranchOrderService";

export const BranchOrderContext = createContext("BranchOrderContext");

const BranchOrderContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [totalElements, setTotalElements] = useState(0);
    const [branchOrderList, setBranchOrderList] = useState([]);

    const [orderHistoryLoading, setOrderHistoryLoading] = useState(null);
    const [orderHistoryList, setOrderHistoryList] = useState([]);

    const [branchOrderCountByStatus, setBranchOrderCountByStatus] = useState(null);
    const [branchOrderCountLoading, setBranchOrderCountLoading] = useState(false);

    const [askHostList, setAskHostList] = useState(null);
    const [askHostLoading, setAskHostLoading] = useState(false);


    const getAskHostList = async () => {
        try {

            setAskHostLoading(true);

            const res = await BranchOrderService.getAskHost();
            setAskHostList(res.data);
            // setTotalElements(res.data.totalElements);

            setAskHostLoading(false);

            return res.data;

        } catch (error) {

            setAskHostLoading(false);

            const message = getErrorMessage(error);
            Toast("error", "Error", message);

        }
    }


    const getAllBranchOrder = async params => {
        try {

            setLoading(true);

            const res = await BranchOrderService.getAllBranchOrder(params);
            setBranchOrderList(res.data.content);
            setTotalElements(res.data.totalElements);

            setLoading(false);

        } catch (error) {

            setLoading(false);

            const message = getErrorMessage(error);
            Toast("error", "Error", message);

        }
    }

    const getBranchOrderCountByStatus = async (params) => {
        try {

            setBranchOrderCountLoading(true);

            const res = await BranchOrderService.getBranchOrderCountByStatus(params);

            delete res.data.catering;
            delete res.data.online;

            setBranchOrderCountByStatus(res.data);

            setBranchOrderCountLoading(false);

        } catch (error) {

            setBranchOrderCountLoading(false);

            const message = getErrorMessage(error);
            Toast("error", "Error", message);

        }
    }

    const getBranchOrderHistory = async orderId => {
        try {

            setOrderHistoryLoading(false)

            const res = await BranchOrderService.getBranchOrderHistory(orderId);
            setOrderHistoryList(res.data);

            setOrderHistoryLoading(false);

        } catch (error) {

            setOrderHistoryLoading(false);

            const message = getErrorMessage(error);
            Toast("error", "Error", message);

        }
    }

    return (
        <BranchOrderContext.Provider
            value={{
                loading,
                orderHistoryLoading,
                totalElements,
                setTotalElements,
                branchOrderList,
                orderHistoryList,
                setBranchOrderList,
                branchOrderCountByStatus,
                branchOrderCountLoading,
                getAllBranchOrder,
                getBranchOrderHistory,
                getBranchOrderCountByStatus,
                askHostList,
                askHostLoading,
                getAskHostList
            }}
        >
            {children}
        </BranchOrderContext.Provider>
    );
}

export default BranchOrderContextProvider;
